export default __webpack_public_path__ + "static/media/draw-table-mobile.47774ea1.png";